<div class="page-card">
  <h1>Relatórios</h1>
  <p>Área preparada para emissão de relatórios, consolidações e apoio ao laudo.</p>
</div>
